export default ({ app, $api, store }) => {
  store.registerModule(
    'client',
    {
      namespaced: true,
      state: () => ({
        application: false,
        loan: false,
        offer: false,
        paymentSchedule: false,
      }),
      getters: {
        active(state, getters, { auth }) {
          return auth.user;
        },
        application(state) {
          return state.application;
        },
        rollovers({ loan }) {
          if (loan) {
            const { rollovers = [] } = loan;
            return rollovers.filter(
              ({ status, invoices }) =>
                status === 'inactive' &&
                invoices.some(invoice => invoice.status === 'unpaid' || invoice.status === 'draft')
            );
          }

          return [];
        },
        expensiveExtension(state, getters) {
          return getters.rollovers.find(rollover => rollover.type === 'expensive') || {};
        },
        cheapExtension(state, getters) {
          return getters.rollovers.find(rollover => rollover.type === 'cheap') || {};
        },
      },
      mutations: {
        SET(state, { key, value }) {
          if (key in state) state[key] = value;
        },
        reset(state) {
          state.application = false;
          state.loan = false;
          state.offer = false;
          state.paymentSchedule = false;
        },
        setApplicationStatus({ application }, payload) {
          if (application) application.status = payload;
        },
      },
      actions: {
        async createApplication(
          { commit, rootGetters },
          {
            amount = rootGetters['arithmetic/amount'].current,
            term = rootGetters['arithmetic/term'].current,
            ...payload
          } = {}
        ) {
          const ioBB = document.getElementById('ioBB');
          const response = await $api.dispatch('client/createApplication', {
            loanAmount: {
              amount,
              currency: app.$tools.currency.global,
            },
            term: {
              value: term,
              unit: 'day',
            },
            iovation: {
              ioBB: ioBB && ioBB.value,
            },
            ...app.$cookies.get('affiliate'),
            ...payload,
          });
          const { success, data } = response;
          if (success) {
            app.$cookies.remove('affiliate', { path: '/' });
            commit('SET', { key: 'application', value: data });
          }

          return response;
        },
        async updateApplication({ commit, state }, payload) {
          const id = state.application.id;
          const response = await $api.dispatch('client/updateApplication', { id, payload });
          if (response.success) commit('SET', { key: 'application', value: response.data });
          return response;
        },
        async getApplication({ commit }) {
          const { success, data } = await $api.dispatch('client/getApplication');
          if (success) commit('SET', { key: 'application', value: data });
        },
        async getApplicationStatus({ commit }) {
          const { success, data } = await $api.dispatch('client/getApplicationStatus');
          if (success) commit('setApplicationStatus', data.status);
        },
        async getApplicationOffer({ state, commit }, force) {
          if (state.offer && !force) return;
          const { success, data } = await $api.dispatch('client/getApplicationOffer');
          if (success) commit('SET', { key: 'offer', value: data });
        },
        async getLoan({ state, commit }, force) {
          if (state.loan && !force) return;
          const { success, data } = await $api.dispatch('client/getLoan');
          if (success) commit('SET', { key: 'loan', value: data });
        },
        async updateLimit({ getters, commit }) {
          if (getters.active) {
            const { success, data } = await $api.dispatch('client/updateLimit');
            if (success) commit('auth/SET', { key: 'user', value: data }, { root: true });
            return success;
          }
        },
        async approveDecrease({ state, dispatch }) {
          const { status } = state.application;
          const { APPLICATION_SPECIAL_OFFER } = app.$tools.status;
          let response;

          if (status === APPLICATION_SPECIAL_OFFER) {
            response = await $api.dispatch('client/approveSpecialDecrease');
          } else {
            response = await $api.dispatch('client/approveYhatDecrease');
          }

          if (response.success) await dispatch('getApplication');
          return response;
        },
        async approveIncrease({ rootGetters, dispatch }) {
          const response = await $api.dispatch('client/approveIncrease', {
            amount: {
              amount: rootGetters['arithmetic/amount'].current,
              currency: app.$tools.currency.global,
            },
            term: {
              value: rootGetters['arithmetic/term'].current,
              unit: 'day',
            },
          });

          if (response.success) await dispatch('getApplication');
          return response;
        },
        async refuseIncrease({ state, dispatch }) {
          const response = await $api.dispatch('client/approveIncrease', {
            amount: {
              amount: state.application.desiredLoanAmount.amount,
              currency: app.$tools.currency.global,
            },
            term: {
              value: state.application.term.value,
              unit: 'day',
            },
          });

          if (response.success) await dispatch('getApplication');
          return response;
        },

        async getActivePaymentSchedule({ state, commit }, force) {
          if (state.paymentSchedule && !force) return;
          const { success, data } = await $api.dispatch('client/getActivePaymentSchedule');
          if (success) commit('SET', { key: 'paymentSchedule', value: data });
        },

        async getApplicationPaymentMethod({ commit }) {
          const { success, data } = await $api.dispatch('client/getApplicationPaymentMethod');
          if (success) commit('SET', { key: 'applicationPaymentMethod', value: data });
        },
      },
    },
    {
      preserveState: process.browser && !process.env.SPA,
    }
  );

  store.watch(
    state => state.auth.user,
    user => {
      if (!Object.keys(user).length) store.commit('client/reset');
    }
  );
};
